export enum TimeframeEnum {
    ALL = 'all',
    MANUAL = 'manual',
    YEARLY = 'yearly',
    MONTHLY = 'monthly',
    WEEKLY = 'weekly',
    DAILY = 'daily',
}

export const isManualObj = (
    x: string | boolean | TimeframeManualDetail | TimeframeDetail,
): x is TimeframeManualDetail => {
    if (typeof x === 'object') {
        return 'start_dates' in x;
    }
    return false;
};

export interface TimeframeDetail {
    archive: boolean | string;
    retention: number | string;
    rotation_trigger: number | string;
}
export interface TimeframeManualDetail {
    archive: boolean | string;
    retention: number | string;
    start_dates: number[];
    // manual: boolean;
}
export interface LeaderboardDetail {
    data?: string;
    name: string;
    order?: 'descending' | 'ascending';
    score_config: {
        capacity: number;
        has_data: boolean;
        type: 'insertonly' | string;
    };
    timeframes: {
        [key in TimeframeEnum]: boolean | TimeframeManualDetail | TimeframeDetail | undefined;
    };
}
export interface TimeframeDetailErrors {
    archive?: string | undefined;
    retention?: string | undefined;
    rotation_trigger?: string | undefined;
}

export interface TimeframeManualDetailErrors {
    archive?: string | undefined;
    retention?: string | undefined;
    start_dates?: string | undefined;
}
export interface LeaderboardDetailErrors {
    data?: string;
    name: string;
    order: string;
    score_config: {
        capacity?: string;
        has_data?: string;
        type?: string;
    };
    timeframes: {
        [TimeframeEnum.ALL]: string;
        [TimeframeEnum.MANUAL]?: TimeframeManualDetailErrors;
        [TimeframeEnum.YEARLY]?: TimeframeDetailErrors;
        [TimeframeEnum.MONTHLY]?: TimeframeDetailErrors;
        [TimeframeEnum.WEEKLY]?: TimeframeDetailErrors;
        [TimeframeEnum.DAILY]?: TimeframeDetailErrors;
    };
}
